/**
 * 分析过程相关的混入
 * 包含分析过程的处理以及转HTML方法
 */
import { EventSourcePolyfill } from "event-source-polyfill";
import { getRobotIcon2Base64 } from "@/utils/svgToBase64.js";
import { request } from "@/utils/request.js"; // 引入request
import { toolApi } from "@/aips/canvas/aiCanvasApi.js";
import JSONFormatter from "../JSONFormatter"; // 修正JSONFormatter导入路径
export default {
  data() {
    return {};
  },
  methods: {
    // 专门用于分析过程的简单Markdown转HTML方法
    convertAnalysisMarkdownToHtml(markdown) {
      // console.log("专门用于分析过程的简单Markdown转HTML方法");
      // console.log(markdown);

      try {
        // 首先处理代码块，避免内部内容被其他规则干扰
        let processedMarkdown = markdown;
        const codeBlocks = [];

        // 提取所有代码块并替换为占位符
        processedMarkdown = processedMarkdown.replace(
          /```(\w*)\n([\s\S]*?)```/g,
          (match, lang, code) => {
            const placeholder = `__CODE_BLOCK_${codeBlocks.length}__`;
            codeBlocks.push({
              lang,
              code: code.trim(),
              placeholder,
            });
            return placeholder;
          }
        );

        // 处理其他Markdown语法
        let html = this.escapeHtml(processedMarkdown)
          // 处理加粗文本
          .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
          // 处理行内代码
          .replace(
            /`([^`]+)`/g,
            '<code style="background-color: #f6f8fa; padding: 2px 4px; border-radius: 3px; font-family: monospace;">$1</code>'
          )
          // 处理换行符
          .replace(/\n\n/g, "</p><p>")
          .replace(/\n/g, "<br>");

        // 还原代码块
        codeBlocks.forEach((block) => {
          const language = block.lang || "plaintext";
          const escapedCode = this.escapeHtml(block.code);
          let codeHtml;

          // 特殊处理JSON格式
          if (language === "json" && block.code) {
            try {
              JSON.parse(block.code);
              // 使用JSONFormatter格式化JSON
              codeHtml = JSONFormatter.format(block.code);
            } catch (e) {
              console.warn("JSON格式化失败:", e);
              codeHtml = `
                    <div class="code-block-container">
                      <div class="code-block-header">
                        <div class="code-language">${language}</div>
                      </div>
                      <pre class="code-block-content"><code class="language-${language}">${escapedCode}</code></pre>
                    </div>
                  `;
            }
          } else {
            codeHtml = `
                  <div class="code-block-container">
                    <div class="code-block-header">
                      <div class="code-language">${language}</div>
                    </div>
                    <pre class="code-block-content"><code class="language-${language}">${escapedCode}</code></pre>
                  </div>
                `;
          }

          html = html.replace(block.placeholder, codeHtml);
        });

        // 包裹在段落标签中
        return `<p>${html}</p>`;
      } catch (error) {
        console.error("分析过程Markdown转HTML出错:", error);
        return `<p>${this.formatUserMessageContent(markdown)}</p>`;
      }
    },

    // 处理分析过程事件
    async handleAnalysisProcess(event) {
      console.log("收到分析过程事件:", event.data);

      try {
        // 解析事件数据
        let processData = event.data;

        const startTime = new Date().getTime();

        toolApi(processData).then((res) => {
          console.log("我是后端返回的数据");
          // console.log(res.data);
          console.log(processData);
          console.log(event.data);
          console.log(processData.toolDescription);

          if (res.code == 200) {
            // 计算接口调用时间
            const endTime = new Date().getTime();
            const callTime = endTime - startTime;

            // 直接使用后端返回的分析文本，不做额外处理
            const analysisResult = res.data.toolAnalysisText;
            const analysisName = JSON.parse(processData).toolDescription;
            console.log("分析过程结果:", analysisResult);
            console.log("分析过程结果:", analysisName);

            // 添加到分析过程数组
            this.analysisProcesses.push({
              id: "analysis-" + Math.random().toString(36).substring(2, 15),
              content: analysisResult,
              name: analysisName,
              collapsed: false, // 默认展开
              callTime: callTime, // 添加接口调用时间
            });

            // 更新或创建分析过程消息
            this.updateAnalysisProcessMessage();
          } else {
            console.error("获取分析过程失败:", res);
            // 显示错误信息
            this.analysisProcesses.push({
              id:
                "analysis-error-" + Math.random().toString(36).substring(2, 15),
              content: "获取分析过程失败，请稍后再试。",
              collapsed: false,
            });
            this.updateAnalysisProcessMessage();
          }
        });
      } catch (error) {
        console.error("处理分析过程事件时出错:", error);
        // 如果处理过程中出错，显示错误信息
        this.analysisProcesses.push({
          id: "analysis-error-" + Math.random().toString(36).substring(2, 15),
          content: "处理分析过程时出错，请稍后再试。",
          collapsed: false,
        });
        this.updateAnalysisProcessMessage();
      }
    },

    // 更新或创建分析过程消息
    updateAnalysisProcessMessage() {
      // 获取SVG Base64 URL
      const robotIcon = getRobotIcon2Base64();

      // 生成包含所有分析过程的HTML内容
      const htmlContent = this.generateAnalysisProcessesHtml();

      // 将分析过程直接添加到当前AI消息内容的前面
      if (this.currentAiMessage) {
        // 将分析过程内容添加到当前AI消息的前面
        const originalContent = this.convertMarkdownToHtml(
          this.markdownContent
        );
        this.currentAiMessage.content = htmlContent + originalContent;

        // 更新消息显示
        this.updateLastAiMessage();

        // 标记已插入分析过程
        this.analysisMessageInserted = true;
      } else {
        // 如果当前没有AI消息，则创建一个新的分析过程消息
        if (!this.analysisMessageInserted) {
          // 首次创建分析过程消息
          this.analysisMessageId =
            "analysis-msg-" + Math.random().toString(36).substring(2, 15);

          const analysisMessage = {
            _id: this.analysisMessageId,
            content: htmlContent,
            senderId: "ai",
            username: "AI助手",
            avatar: robotIcon,
            html: true,
            date: new Date().toLocaleDateString(),
            isAnalysisProcess: true, // 标记为分析过程消息
          };

          // 添加到消息列表末尾
          this.messages.push(analysisMessage);
          this.analysisMessageInserted = true;
        } else {
          // 更新现有的分析过程消息
          const analysisMessageIndex = this.messages.findIndex(
            (msg) => msg._id === this.analysisMessageId
          );
          if (analysisMessageIndex !== -1) {
            this.messages[analysisMessageIndex].content = htmlContent;
          }
        }
      }

      // 添加折叠/展开功能
      this.$nextTick(() => {
        this.setupAnalysisProcessCollapsibles();
      });
    },

    // 生成包含所有分析过程的HTML内容
    generateAnalysisProcessesHtml() {
      if (this.analysisProcesses.length === 0) {
        return "";
      }

      let html = `<div class="analysis-processes-container">
                    <div class="analysis-processes-header">
                      <h3>分析过程 (${this.analysisProcesses.length})</h3>
                      <div class="analysis-controls">
                        <span class="toggle-all-btn" onclick="toggleAllAnalysisProcesses(); event.stopPropagation();">
                        <i class="toggle-arrow down"></i>
                        </span>
                      </div>
                    </div>`;

      // 添加每个分析过程
      this.analysisProcesses.forEach((process) => {
        // 默认为折叠状态
        const collapsedClass = "collapsed";
        const collapsedIcon = "+";
        const btnClass = "collapse-btn collapse-btn-plus"; // 默认为加号样式

        html += `<div class="analysis-process-item ${collapsedClass}" data-process-id="${
          process.id
        }">
                  <div class="analysis-process-header" onclick="toggleAnalysisProcess('${
                    process.id
                  }')">
                    <span class="${btnClass}" onclick="toggleAnalysisProcess('${
          process.id
        }'); event.stopPropagation();">${collapsedIcon}</span>
                    <span class="analysis-process-title">工具调用-${this.escapeHtml(
                      process.name
                    )}</span>
                    ${
                      process.callTime
                        ? `<span class="api-call-time">${process.callTime} ms <span class="checkmark">✓</span></span>`
                        : ""
                    }
                  </div>
                  <div class="analysis-process-content" id="content-${
                    process.id
                  }">
                    ${this.convertAnalysisMarkdownToHtml(process.content)}
                  </div>
                </div>`;
      });

      html += `</div><div style="margin-top: 10px;"></div>`;

      return html;
    },

    // 设置分析过程的折叠/展开功能
    setupAnalysisProcessCollapsibles() {
      // 确保全局函数可用
      if (typeof window !== "undefined" && !window.toggleAnalysisProcess) {
        window.toggleAnalysisProcess = function (id) {
          const item = document.querySelector(
            `.analysis-process-item[data-process-id="${id}"]`
          );
          if (item) {
            const btn = item.querySelector(".collapse-btn");

            if (item.classList.contains("collapsed")) {
              item.classList.remove("collapsed");
              if (btn) btn.textContent = "-";
            } else {
              item.classList.add("collapsed");
              if (btn) btn.textContent = "+";
            }
          }
        };
      }

      // 添加切换所有分析过程展开/折叠的全局函数
      if (typeof window !== "undefined" && !window.toggleAllAnalysisProcesses) {
        // 初始化全局状态变量
        window.allExpanded = false;

        window.toggleAllAnalysisProcesses = function () {
          const arrow = document.querySelector(".toggle-arrow");
          const items = document.querySelectorAll(".analysis-process-item");

          // 切换状态
          window.allExpanded = !window.allExpanded;

          if (window.allExpanded) {
            // 展开所有
            items.forEach((item) => {
              item.classList.remove("collapsed");
              const btn = item.querySelector(".collapse-btn");
              if (btn) {
                btn.textContent = "-";
                btn.classList.remove("collapse-btn-plus");
                btn.classList.add("collapse-btn-minus");
              }
            });
            // 更新箭头方向
            if (arrow) {
              arrow.classList.remove("down");
              arrow.classList.add("up");
            }
          } else {
            // 折叠所有
            items.forEach((item) => {
              item.classList.add("collapsed");
              const btn = item.querySelector(".collapse-btn");
              if (btn) {
                btn.textContent = "+";
                btn.classList.remove("collapse-btn-minus");
                btn.classList.add("collapse-btn-plus");
              }
            });
            // 更新箭头方向
            if (arrow) {
              arrow.classList.remove("up");
              arrow.classList.add("down");
            }
          }
        };
      }
    },

    // 重置分析过程数据
    resetAnalysisProcesses() {
      this.analysisProcesses = [];
      this.analysisMessageInserted = false;
      this.analysisMessageId = null;

      // 移除之前的分析过程消息
      if (this.analysisMessageId) {
        const index = this.messages.findIndex(
          (msg) => msg._id === this.analysisMessageId
        );
        if (index !== -1) {
          this.messages.splice(index, 1);
        }
      }
    },
  },
  mounted() {
    // 添加全局JSON折叠函数
    if (typeof window !== "undefined" && !window.toggleJsonCollapse) {
      window.toggleJsonCollapse = function (id) {
        const element = document.getElementById(id);
        if (element) {
          const parent = element.parentNode;
          parent.classList.toggle("json-formatter-collapsed");
        }
      };
    }

    // 添加全局分析过程折叠函数
    if (typeof window !== "undefined" && !window.toggleAnalysisProcess) {
      window.toggleAnalysisProcess = function (id) {
        const item = document.querySelector(
          `.analysis-process-item[data-process-id="${id}"]`
        );
        if (item) {
          const btn = item.querySelector(".collapse-btn");

          if (item.classList.contains("collapsed")) {
            item.classList.remove("collapsed");
            if (btn) {
              btn.textContent = "-";
              btn.classList.remove("collapse-btn-plus");
              btn.classList.add("collapse-btn-minus");
            }
          } else {
            item.classList.add("collapsed");
            if (btn) {
              btn.textContent = "+";
              btn.classList.remove("collapse-btn-minus");
              btn.classList.add("collapse-btn-plus");
            }
          }
        }
      };
    }

    // 添加切换所有分析过程展开/折叠的全局函数
    if (typeof window !== "undefined" && !window.toggleAllAnalysisProcesses) {
      // 初始化全局状态变量
      window.allExpanded = false;

      window.toggleAllAnalysisProcesses = function () {
        const arrow = document.querySelector(".toggle-arrow");
        const items = document.querySelectorAll(".analysis-process-item");

        // 切换状态
        window.allExpanded = !window.allExpanded;

        if (window.allExpanded) {
          // 展开所有
          items.forEach((item) => {
            item.classList.remove("collapsed");
            const btn = item.querySelector(".collapse-btn");
            if (btn) {
              btn.textContent = "-";
              btn.classList.remove("collapse-btn-plus");
              btn.classList.add("collapse-btn-minus");
            }
          });
          // 更新箭头方向
          if (arrow) {
            arrow.classList.remove("down");
            arrow.classList.add("up");
          }
        } else {
          // 折叠所有
          items.forEach((item) => {
            item.classList.add("collapsed");
            const btn = item.querySelector(".collapse-btn");
            if (btn) {
              btn.textContent = "+";
              btn.classList.remove("collapse-btn-minus");
              btn.classList.add("collapse-btn-plus");
            }
          });
          // 更新箭头方向
          if (arrow) {
            arrow.classList.remove("up");
            arrow.classList.add("down");
          }
        }
      };
    }
  },
};
